<div class="welldone-card">
    <div class="welldone-card-header">
        Barcode
    </div>
    <div class="welldone-card-body">
        <form #barcodeForm="ngForm" class="w-100">

            <div class="container-fluid">
                <div class="row mb-3">
                    <div class="col-4">
                        <label class="form-label required">Barcode</label>
                        <input type="text" class="form-control form-control-solid"
                               [(ngModel)]="barcode.barcode" name="barcode" required/>
                    </div>
                    <div class="col-4">
                        <label class="form-label required">Taglia</label>
                        <welldone-multiselect
                                                 [placeholder]="'Seleziona le taglie disponibili'"
                                                 [settings]="productDropdownSettings"
                                                 [(ngModel)]="selectedSizes"
                                                 [data]="sizesList"
                                                 [ngModelOptions]="{standalone: true}">
                        </welldone-multiselect>
                    </div>
                    <div class="col-4">
                        <label class="form-label required">Colore</label>
                        <welldone-multiselect
                                                 [placeholder]="'Seleziona i colori disponibili'"
                                                 [settings]="productDropdownSettings"
                                                 [data]="colorsList"
                                                 [(ngModel)]="selectedColors"
                                                 [ngModelOptions]="{standalone: true}"
                        >
                        </welldone-multiselect>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="welldone-card-footer">
        <div class="d-flex justify-content-end">
            <button class="btn btn-secondary" (click)="previousPage()" style="margin-right: 10px">
                Annulla
            </button>
            <button class="btn btn-primary" *ngIf="editPage; else addPageBtn"
                    [disabled]="barcodeForm.invalid"
                    (click)="editBarcode()">
                Modifica
            </button>
            <ng-template #addPageBtn>
                <button class="btn btn-primary"
                        [disabled]="barcodeForm.invalid"
                        (click)="addBarcode()"> Crea
                </button>
            </ng-template>
        </div>
    </div>
</div>

<br>

<app-shop-movement [barcodeId]="barcodeId" *ngIf="editPage"></app-shop-movement>
